export default __webpack_public_path__ + "assets/images/safe-secure-c57d25db93e36cc211ce7ca8adda158d.svg";